import {events}      from "../../commun/backbone/decorators";
import LoginBaseView from "./login-base-view";
import Routing       from "../app/router";

@events({
            'input .otp-input': '_onInputDigit',
            'keydown .otp-input': '_onKeydownDigit',
            'paste .otp-input': '_onPasteDigit',
            'click #btn-resendcode': '_onClickResendCode',
        })
    /**
     * @property {LoginModel} model
     */
class LoginOtpView extends LoginBaseView
{
    initialize(options)
    {
        super.initialize(options);


    }

    render()
    {
        super.render();
        this.$OtpValue = this.$el.find('#otp-value');
        this.$inputs = this.$el.find('.otp-input');
        this.$btnsend = this.$el.find('#btn-resendcode');
        this.$timer  = this.$el.find('#btn-timer');
        this._startCountdown();
    }

    _onInputDigit(event)
    {
        const value = event.originalEvent.data?.replace(/\D/g, '') || '';
        event.target.value = value;

        const index = $(event.target).data("idx");
        if (value && index < this.$inputs.length - 1) {
            this.$inputs[index + 1].focus();
        }

        this._updateOtpValue();
    }

    _onKeydownDigit(event)
    {
        const $target = $(event.target);
        const index = $target.data("idx");
        if (((event.key === 'Backspace') || (event.key === 'ArrowLeft')) && (index > 0)) {
            if (event.key === 'Backspace') {
                event.target.value = '';
                event.preventDefault();
                this._updateOtpValue();
            }
            this.$inputs[index - 1].focus();
        }
        if ((event.key === 'ArrowRight') && (index < this.$inputs.length - 1)) {
            this.$inputs[index + 1].focus();
        }
    }
    _onPasteDigit(event)
    {
        event.preventDefault();
        const paste = event.originalEvent.clipboardData.getData('text').replace(/\D/g, '');
        paste.split('').slice(0, this.$inputs.length).forEach((char, i) => {
            this.$inputs[i].value = char;
        });
        this.$inputs[Math.min(paste.length, this.$inputs.length) - 1].focus();
        this._updateOtpValue();
    }
    _updateOtpValue()
    {
        this.$OtpValue.val(Array.from(this.$inputs).map(i => i.value).join(''));
    }

    _onClickResendCode(event)
    {
        event.preventDefault();
        this._startCountdown();
        this.model.resendOtpCode().then(e => {
            window.location = Routing.generate('session_login');
        });
    }
    _startCountdown(seconds = 30)
    {
        let remaining = seconds;

        // désactiver le bouton
        this.$btnsend.attr('disabled', 'disabled');
        this._updateTimer(remaining);

        // lancer le compte à rebours
        this.countdown = setInterval(() => {
            remaining--;
            this._updateTimer(remaining);

            if (remaining <= 0) {
                clearInterval(this.countdown);
                this.$btnsend.removeAttr('disabled');  // réactiver le bouton
                this.$timer.text('');      // effacer le timer
            }
        }, 1000);
    }
    _updateTimer(remaining)
    {
        this.$timer.text(`(${remaining}s)`);
    }
}
export default LoginOtpView;